<template>
  <el-dialog
    :close-on-click-modal="false"
    title="订单模式导入操作步骤"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1100px"
  >
    <section>
      <el-carousel trigger="click" :autoplay="false" height="550px">
        <el-carousel-item>
          <h2>第一步</h2>
          <img style="width: 100%;height:100%" src="~images/operate/oneSteps.png"/>
        </el-carousel-item>
        <el-carousel-item>
          <h2>第二步</h2>
          <img style="width: 100%;height:100%" src="~images/operate/twoSteps.png"/>
        </el-carousel-item>
        <el-carousel-item>
          <h2>第三步</h2>
          <img style="width: 100%;height:100%" src="~images/operate/threeSteps.png"/>
        </el-carousel-item>
      </el-carousel>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
    },
  },
};
</script>

<style scoped lang="scss">
//.introImg{
//  width: 100%;
//  margin-bottom: 24px;
//}
.el-carousel__item h2 {
  color: red;
  font-weight: bolder;
  font-size: 18px;
  //opacity: 0.75;
  //line-height: 300px;
  //margin: 0;
}

//.el-carousel__item:nth-child(2n) {
//  background-color: #99a9bf;
//}
//
//.el-carousel__item:nth-child(2n+1) {
//  background-color: #d3dce6;
//}
</style>
